module.exports = __webpack_public_path__ + "static/img/s29.69caa352.png";